package com.yet.tetris.domain.model.game

data class GameBoard(
    val width: Int = 10,
    val height: Int = 20,
    val cells: Map<Position, TetrominoType> = emptyMap(),
) {
    data class ClearLinesResult(
        val board: GameBoard,
        val linesCleared: Int,
        val clearedRows: List<Int>,
    )

    fun isPositionOccupied(position: Position): Boolean = cells.containsKey(position)

    fun isPositionValid(position: Position): Boolean = position.x in 0 until width && position.y >= 0 && position.y < height

    fun lockPiece(
        piece: Tetromino,
        offset: Position,
    ): GameBoard {
        val newCells = cells.toMutableMap()
        piece.getAbsolutePositions(offset).forEach { pos ->
            newCells[pos] = piece.type
        }
        return copy(cells = newCells)
    }

    fun clearLinesDetailed(): ClearLinesResult {
        val completedLines =
            (0 until height).filter { y ->
                (0 until width).all { x -> cells.containsKey(Position(x, y)) }
            }

        if (completedLines.isEmpty()) {
            return ClearLinesResult(
                board = this,
                linesCleared = 0,
                clearedRows = emptyList(),
            )
        }

        val newCells = mutableMapOf<Position, TetrominoType>()
        var targetY = height - 1

        for (y in (height - 1) downTo 0) {
            if (y !in completedLines) {
                for (x in 0 until width) {
                    val pos = Position(x, y)
                    cells[pos]?.let { type ->
                        newCells[Position(x, targetY)] = type
                    }
                }
                targetY--
            }
        }

        return ClearLinesResult(
            board = copy(cells = newCells),
            linesCleared = completedLines.size,
            clearedRows = completedLines,
        )
    }

    fun clearLines(): Pair<GameBoard, Int> {
        val result = clearLinesDetailed()
        return result.board to result.linesCleared
    }
}
